/**
 * Bounds of the transient-error self-recovery (LIIP-1009 contract: "transient self-clearing;
 * cleared after success; WorkQueue 503 transient"). Used by transientErrorRefetch.ts.
 *
 * This file has no imports on purpose: the LIIP-1009 e2e harness reads these values too, so
 * the specs follow the product values without loading the widget source.
 */

/** Interval of the quick refetches right after a transient failure. */
export const TRANSIENT_ERROR_REFETCH_MS = 5000;

/**
 * Jitter of every transient refetch interval: each wait is a random value between
 * (1 - TRANSIENT_ERROR_JITTER_RATIO) and 1 times its constant, so open tabs do not repeat in
 * lockstep against a failing API. Never longer than the constant.
 */
export const TRANSIENT_ERROR_JITTER_RATIO = 0.5;

/**
 * Number of quick refetches in each outage window (see transientErrorRefetch). After them the
 * view backs off.
 */
export const TRANSIENT_ERROR_MAX_REFETCHES = 6;

/** Interval of the slow refetches after the quick ones, until the outage stop. */
export const TRANSIENT_ERROR_BACKOFF_MS = 60_000;

/**
 * Time after the first failure of an outage at which the quick and slow refetches stop. After
 * it the view asks again only every TRANSIENT_ERROR_HEARTBEAT_MS; it also re-checks on
 * visibilitychange, window focus and the browser `online` event (useTransientErrorWake) and
 * keeps its Retry control.
 */
export const TRANSIENT_ERROR_STOP_AFTER_MS = 10 * 60_000;

/**
 * Interval of the slow heartbeat after the outage stop, so a focused tab still recovers when
 * the API comes back. A heartbeat that fails again stays on the heartbeat (no new outage
 * window) until a success ends the outage.
 */
export const TRANSIENT_ERROR_HEARTBEAT_MS = 5 * 60_000;

/**
 * One wake re-check per return to the page: a tab return fires both visibilitychange and
 * window focus, so useTransientErrorWake ignores a wake event within this time after its
 * last re-check.
 */
export const TRANSIENT_ERROR_WAKE_DEDUPE_MS = 1000;
